module.exports = __webpack_public_path__ + "img/PortadaA.dacd2e7d.svg";